import {Button} from '../Footer'
import Price from './components/Price'
import {useContext, useState} from 'react'
import {OrderDataContext} from '../../context/OrderDataContext'
import {OrderItemsContext} from '../../context/OrderItemsContext'
import {ReservationContext} from '../../context/ReservationContext'
import {ErrorContext} from '../../context/ErrorContext'
import Api from "../../api/api";
import { TranslationContext } from '../../context/TranslationContext'

function Review({setPage}) {
    const {order, setOrder} = useContext(OrderDataContext)
    const {reservation} = useContext(ReservationContext)
    const {orderItems} = useContext(OrderItemsContext)
    const {setErrors} = useContext(ErrorContext)
    const {translations} = useContext(TranslationContext)
    const [loading, setLoading] = useState(false)

    const onConfirm = () => {
        let hasErrors = false

        if (!order.time) {
            setErrors((prev) => ({...prev, time: true}))
            hasErrors = true
        }

        if (!order.location) {
            setErrors((prev) => ({...prev, location: true}))
            hasErrors = true
        }

        if (hasErrors) {
            return
        }

        setLoading(true)
        Api.saveOrder({
            order: order,
            reservation: reservation,
            items: orderItems,
        }).then(() => {
            setOrder((prev) => ({...prev, success: true}))

            Api.notify({
                text: 'Order created!',
                data: {
                    reservationCode: reservation.code,
                    name: reservation.name,
                    date: order.date,
                    time: order.time,
                }
            });
            setPage('success')
        }).catch((e) => {
            alert('error')
        }).finally(() => {
            setLoading(false)
        })
    }

    return <>
        <Button onClick={onConfirm} disabled={loading}>{translations.action_send}</Button>
        <br />
        <Price />
    </>
}

export default Review;
